<template>
  <section class="modal adduser" @click="changeState({element: 'invite', val: false})">
    <div class="modal-wrap">
    <div class="modal-block" @click.prevent.stop>
      <!-- Поиск -->
        <div class="timeline-string">
      <div class="search">
        <div class="search-input">
          <img class="search__icon" src="@/assets/images/icons/icon_search.svg">
          <input type="search" placeholder="Ищи ветра в поле" v-model="search" @keyup.enter="searchByTitle">
          <p v-if="search.length > 2" class="search__label">Нажмите Enter</p>
        </div>
      </div>

    <!-- Фильтры -->
      <div class="timeline-buttons">
        <div class="map-button map-button_rainbow" @click="changeState({element: 'sports'})" v-if="!friends">
          <p>Категории</p>
        </div>
        <div class="button" @click="myFriends()" :class="{active: friends}">Мои друзья</div>
      </div>
      </div>
      <Sports :sports="getActiveSports" v-if="!friends"/>
      <div class="modal-body" v-if="getActiveChat && users && users.users.length > 0">
        
        <div class="people" @click="addUser(user)" v-for="user in users.users" :key="user.id" :class="{
            cover: user.cover ? 'cover' : '', 
            active: hasInvited(user) || alreadyJoined(user)}"
            :style="{backgroundImage: 'url('+ user.cover +')'}"
            >
            <div class="chouse-check">
              <img src="@/assets/images/icon_check-user.svg" width="16px">
            </div>
            <div class="people-avatar" :style="{backgroundImage: 'url('+ user.avatar +')', backgroundPosition: user.avatar_position}">
                <!-- <div class="people-rate" v-if="user.rate" :title="user.rate.title" :class="user.rate.color">
                    <img :src="require(`@/assets/images/defaults/icon_${user.rate.image}.png`)">
                </div> -->
            </div>
            <p class="people__name">{{ user.firstname + ' ' + user.lastname}}</p>
            <p class="people__status">{{ user.shortdesc }}</p>
            <!-- <p class="people-description">{{ user.city ? user.city.name + ',' : ''}} {{ getSex(user) }}, {{ getExperience(user) || ''}}</p> -->
            <div class="people-category" v-if="user.sports">
                <div v-for="cat in shortSports(user)" :key="cat.id" class="people-category__item" :class="cat.color">{{cat.ru}}</div>
                <div class="people-category__item dark" v-if="user.sports.length > 5">и еще {{user.sports.length - 5}}</div>
            </div>
        </div>
      </div>
      <div class="modal-body" v-else>
        <p class="modal-nothing">Ничего не найдено 💩</p>
      </div>
    </div>
    <div class="chousen-counter" v-if="invited.length > 0" @click="sendInvite()">
      <p>Добавить {{invited.length}} людей</p>
    </div>
    </div>
  </section>
</template>
<script>
import Sports from '@/components/Filters/Sports'

export default {
  name: "ModalInvite",
  data: () => {
    return {
      search: '',
      users: [],
      invited: [],
      friends: false,
      window: null,
      position: null,
      page: 0
    };
  },
  components: {
    Sports
  },
  computed: {
      getActiveSports () {
        return this.$store.getters.getActiveSports
      },
      getActiveChat () {
        return this.$store.getters.getActiveChat
      },
      getUser () {
        return this.$store.getters.getAuthUser
      }
      
  },
  methods: {
    async loadData() {
      let type = this.friends ? 'friends' : '';
      let data = {sports: this.getActiveSports, search: this.search, type: type, user: this.getUser.id, page: this.page};
      this.users = this.friends ?  await this.$store.dispatch('getFriends', data) : await this.$store.dispatch('getUsers', data);
    },
    async loadMore() {
      let type = this.friends ? 'friends' : '';
      let data = {sports: this.getActiveSports, search: this.search, type: type, user: this.getUser.id, page: this.page};
      let users = this.friends ?  await this.$store.dispatch('getFriends', data) : await this.$store.dispatch('getUsers', data);
      this.users.users = this.users.users.concat(users.users);
    },
    shortSports(user) {
      return user.sports.slice(0, 5)
    },
    myFriends () {
      this.friends = !this.friends
      this.loadData()
    },
    changeState (element) {
        this.$store.dispatch('changeState', element)
    },
    hasInvited (user){
      return this.invited.find(item => user.id === item.id) ? true : false
    },
    alreadyJoined (user){
      return this.getActiveChat.users.find(item => user.id === item.id) ? true : false
    },
    addUser (user) {
      let has = this.hasInvited(user);
      let joined = this.alreadyJoined(user);
      if (!has && !joined) {
          this.invited.push(user)
        } else {
            has ? this.invited.splice(this.invited.indexOf(has), 1) : '';
        }
    },
    async sendInvite() {
        let user = {
          id: this.getUser.id,
          firstname: this.getUser.firstname,
          lastname: this.getUser.lastname,
          avatar: this.getUser.avatar
        };
        this.$socket.emit('new_user', {users: this.invited, chat: this.getActiveChat.id, inviter: user})
        this.changeState({element: 'invite', val: false})
    },
    searchByTitle () {
      this.search && this.search.length > 2 ? '' : this.search = null
      this.loadData()
    },
    lazyLoad() {
      let timeout = false;
      this.window.onscroll = () => {
        if (timeout !== false) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(async () => {
          this.position = this.window.scrollHeight - (this.window.scrollTop + this.window.clientHeight);
            if (this.position < 1000) {
              this.page++
              this.loadMore()
            } 
        }, 300);
      }
    },
    scrollHandler() {
      // TODO: переписать
      this.window = document.querySelector(".modal-wrap");
      if (this.window) {
        setTimeout(() => {
          this.lazyLoad()
        }, 1000)
      } else {
        setTimeout(() => {
          this.window = document.querySelector(".modal-wrap");
          this.lazyLoad()
        }, 1000)
      }      
    },
  },
  watch: {
    getActiveSports () {
      this.loadData('sports')
    },
    getUser () {
        this.loadData()
    }
  },
  mounted () {
    this.loadData()
    this.scrollHandler()
  }
};
</script>
<style lang="stylus">
.people
    width 30%
    max-width 315px
    max-width 288px
    width 288px
    border-radius 20px
    background var(--blocks)
    // box-shadow 0 0 15px #eaeaea
    box-shadow 0px 0px 30px rgba(162, 162, 162, 0.2)
    border var(--people-borders)
    padding 25px
    margin 7px
    display flex
    flex-direction column
    align-items center
    position relative
    +to-width(767px)
        margin 7px 0

    &.cover
        background-size cover
        position relative
        overflow hidden
        &:after
            content ''
            position absolute
            left 0
            top 0
            right 0
            bottom 0
            background linear-gradient(0deg, rgba(0,0,0,0.5), transparent)
        .people__name
            color white
        .people-description
            color white
        .people-avatar
            border 4px solid white


    &-avatar
        width 180px
        height 180px
        border-radius 50%
        // background #f0f0f0
        background white
        cursor pointer
        margin-top 15px
        position relative
        z-index 2
        background-size cover
        background-position center
        background-image url('https://mir-s3-cdn-cf.behance.net/project_modules/disp/1bcdd944565991.5817acde24c51.gif')

        &:hover
            .people-elems
                transform rotate(100deg)
                opacity 1
                pointer-events all
    
    &__name
        font-size 16px
        text-align center
        font-weight 600
        color var(--text-main)
        margin-top 25px
        position relative
        z-index 2
        
    &__status
        font-size 14px
        text-align center
        font-weight 500
        font-style italic
        color #b1b0b0
        margin-top 10px
        position relative
        z-index 2
        padding-bottom 15px
        width 100%
        
    
    &-description
        font-size 12px
        font-weight 500
        line-height 16px
        min-height 32px
        color black
        margin-top 16px
        position relative
        z-index 2

    
    &-category
        display flex
        margin-top 10px
        width calc(100% + 10px)
        margin-left -5px
        margin-right -5px
        position relative
        z-index 2
        // justify-content center
        flex-wrap wrap

        &__item
            margin 3px
            padding 8px 14px
            border-radius 50px
            // background-color #333
            color white
            font-size 12px
            font-weight 500
            text-transform lowercase
            // font-style italic
            cursor pointer
            &.dark
                background var(--main)
            &.gray
                background #aaa
                cursor default
    &-rate
        width 37px
        height 37px
        border-radius 50%
        background-color black
        position absolute
        left 5px
        top 5px
        center()
        border 2px solid white
        img
            max-width 60%
        
        &.green
            background-color $green
        
        &.indianred
            background-color indianred
    
    &-elems
        width 100%
        height 100%
        position absolute
        opacity 0
        pointer-events none
        transition all 0.6s
        +to-width(1023px)
            opacity 1
            pointer-events all
            transform rotate(100deg)
            
        &__item
            max-width 37px
            min-width 37px
            height 37px
            border-radius 50%
            border 2px solid white
            background var(--main)
            position absolute
            padding 6px
            cursor pointer
            left 0
            top 0
            img
                max-width 100%
                transform rotate(-100deg)
            p
                transform rotate(-100deg)
                margin-left 5px
                white-space nowrap
                color white
                font-weight 500

            &:nth-child(2)
                left 35px
                top -17px
            &:nth-child(3)
                left 73px
                top -20px
            
            &.green
                background #8fbc8f
    
    &_pseudo
        .people__name
            background-color #f0f0f0
            width 80%
            height 20px
            border-radius 20px
        .people-avatar
            background-image none
        .people-category__item
            background-color #f0f0f0
            width 80px
            height 20px
</style>